import NotificationDot from '@/components/common/NotificationDot';

import { useCoaches } from '@/data/coach';
import { COACH_ACTIVITY_STATUS } from '@/app/coachActivity/enums';

const CoachNotificationDot = () => {
  const coaches = useCoaches();

  if (coaches.isLoading && !coaches.data) {
    return null;
  }

  const hasAnyPendingActivity = coaches.data?.some((coach) =>
    coach.coachActivities.some(
      (coachActivity) =>
        coachActivity.status === COACH_ACTIVITY_STATUS.SUBMITTED &&
        coachActivity.isAgreedToTerms
    )
  );

  if (!hasAnyPendingActivity) {
    return null;
  }

  return (
    <div className="relative">
      <NotificationDot position="-top-10 -right-7" />
    </div>
  );
};

export default CoachNotificationDot;
